<template>
  <div
    v-if="isView"
    id="guides"
    v-guides-view-tracker="analyticsBase"
    class="container"
  >
    <div
      class="title obs-el"
      data-attr="guides"
    >
      Гиды рассказывают
    </div>
    <div class="guides-messages">
      <GuideShare
        v-if="guideData"
        :guide-info="guideData"
        :sight="sight"
      />
      <GuideMessage
        v-for="comment in comments"
        :key="comment.id"
        :comment="comment"
        @guide-click="onGuideClick"
      />
    </div>
    <UiButtonV3
      v-if="hasMore"
      class="view-more-guide-comments-button"
      :variant="UiButtonVariant.OUTLINE"
      :color-mode="UiButtonColorMode.NEUTRAL"
      text="Показать ещё"
      :is-full-width="isMobile"
      :is-loading="isLoading"
      @clicked="onShowMore"
    />
  </div>
</template>

<script setup lang="ts">
  import { useScreenSize } from '@experience/shared';
  import { UiButtonV3, UiButtonColorMode, UiButtonVariant } from '@experience/vue3-kit';
  import { computed } from 'vue';

  import { trackEvent, useViewTracker } from '@/shared/lib/analytics/compat';
  import type { SightGuideComment, SightModalSight } from '@/shared/types/sight-modal';
  import GuideMessage from '@/shared/ui/sights/GuideMessage.vue';
  import GuideShare from '@/shared/ui/sights/GuideShare.vue';

  const props = withDefaults(
    defineProps<{
      sight: SightModalSight;
      comments?: SightGuideComment[];
      guideData?: SightGuideComment | null;
      hasMore?: boolean;
      isLoading?: boolean;
      analyticsBase?: Record<string, unknown>;
    }>(),
    {
      comments: () => [],
      guideData: null,
      hasMore: false,
      isLoading: false,
      analyticsBase: () => ({}),
    },
  );

  const emit = defineEmits<{
    'show-more': [];
    'guide-click': [guideId: number];
  }>();

  const { isMobile } = useScreenSize();

  const vGuidesViewTracker = useViewTracker('around:sights:sight-popup:guides.view');

  const isView = computed(() => props.comments.length > 0 || Boolean(props.guideData));

  const onGuideClick = (guideId: number) => {
    void trackEvent('around:sights:sight-popup:guide.click', { ...props.analyticsBase, guide_id: guideId });
    emit('guide-click', guideId);
  };

  const onShowMore = () => {
    void trackEvent('around:sights:sight-popup:guide-show-more.click', { ...props.analyticsBase });
    emit('show-more');
  };
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .title {
    margin-top: var(--alias-space-48);

    @include base-600-500-extra;
  }

  .guides-messages {
    display: flex;
    flex-direction: column;
    gap: var(--alias-space-16);
    margin-top: var(--alias-space-16);
  }

  .view-more-guide-comments-button {
    margin-top: var(--alias-space-24);
  }
</style>
